import { Injectable } from "@angular/core";
import { EditableGridService, SystemApiService } from "@cv-invision/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ConnexionsMonitorService extends EditableGridService {
	constructor(
		private systemApiService: SystemApiService,
		private httpClient: HttpClient
	) {
		super();
	}

	/**
	 * get a list of logs
	 * @param params are the filter values.
	 */
	getLogs(params: any): Observable<any> {
		const url = `${this.systemApiService.api.connexions}/transactions/logs`;
		return this.httpClient.get(url, { params });
	}

	/**
	 * GET - Return details of a specific order from the second endpoint.
	 */
	getOrderDetails(id: string): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.connexions}/transactions/order/${id}`);
	}
}
